import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { BetSlipType } from '@bpos';
import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { getModuleTypesOrder } from '../../../../../base/utils/linear-utils';
import { BetslipType } from '../../../../../core/betslip-type';
import { ISucceededSlipResult } from '../../../../betplacement/models';
import { isBetBuilderSucceededSlip } from '../../../utils/placed-slip.utils';

@Component({
    selector: 'bs-digital-linear-result-slips',
    templateUrl: './linear-result-slips.component.html',
    styleUrls: ['./linear-result-slips.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearResultSlipsComponent implements OnInit {
    @Input() succeededSlips: ISucceededSlipResult[];
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() inColumn: boolean;

    @HostBinding('class') className = 'betslip-result-slips';

    singleSlips: ISucceededSlipResult[] = [];
    comboSlip: ISucceededSlipResult;
    systemSlips: ISucceededSlipResult[] = [];
    teaserSlip: ISucceededSlipResult;
    betBuilderSlips: ISucceededSlipResult[] = [];
    showOneBetBuilderBetPerModule = false;
    showRewardsCta = false;
    readonly betslipTypes = BetslipType;
    linearBetslipTypesOrder: BetslipType[];

    constructor(private betslipConfig: BetslipConfig) {
        const configuredOrder = this.betslipConfig.linearBetslipTypesOrder;
        this.linearBetslipTypesOrder = getModuleTypesOrder(configuredOrder);
        this.showRewardsCta = this.betslipConfig.isRewardCtaEnabled;
        this.showOneBetBuilderBetPerModule = !this.betslipConfig.isLinearSeparateBetBuilderModuleEnabled;
    }

    ngOnInit(): void {
        this.filterSlips();
    }

    private filterSlips(): void {
        if (!this.succeededSlips) {
            return;
        }

        this.succeededSlips.forEach((slip) => {
            switch (slip.betType) {
                case BetSlipType.Single:
                    if (isBetBuilderSucceededSlip(slip)) {
                        this.betBuilderSlips.push(slip);
                        break;
                    }

                    this.singleSlips.push(slip);
                    break;
                case BetSlipType.Combo:
                    if (slip.picks.some((p) => p.isTeaserBet)) {
                        this.teaserSlip = slip;
                        break;
                    }

                    if (isBetBuilderSucceededSlip(slip)) {
                        this.betBuilderSlips.push(slip);
                        break;
                    }

                    this.comboSlip = slip;
                    break;
                case BetSlipType.System:
                    this.systemSlips.push(slip);
                    break;
            }
        });
    }
}
